export default "__VITE_ASSET__BYy1R4Fe__"